/**
 * 🌍 GLOBAL STANDART KOD (TÜM PROJELER İÇİN GEÇERLİDİR)
 *
 * Bu dosya QubePro ekosisteminde ortak (global) standarttır.
 * Tek kaynak `qubepro-core` reposudur; uydu repolarda kalıcı değişiklik yapılmaz.
 * Değişiklik gerekiyorsa Core'da güncellenir ve senkron ile diğer repolara yayılır.
 */
import { useRef } from 'react';
import { FormModal } from './FormModal';
import { assistantDraftActionCopy, assistantDraftReviewFields, type AssistantDraftAction } from './assistant-draft-actions';
import './AssistantDraftActionReview.css';

export function AssistantDraftActionReview({ action, language, busy, error, surfaceScope, onClose, onConfirm }: {
  action: AssistantDraftAction;
  language?: string;
  busy: boolean;
  error?: string;
  surfaceScope?: 'workspace' | 'viewport';
  onClose: () => void;
  onConfirm: (action: AssistantDraftAction) => Promise<void>;
}) {
  const copy = assistantDraftActionCopy(language), pending = useRef(false);
  const submit = async () => {
    if (busy || pending.current) return;
    pending.current = true;
    try { await onConfirm(action); } finally { pending.current = false; }
  };
  return <FormModal title={copy[action.type]} onClose={() => { if (!busy && !pending.current) onClose(); }}
    size="md" surfaceScope={surfaceScope} maximizable={false} closeOnOverlayClick={false}
    footer={<><button type="button" className="btn btn-secondary" disabled={busy} onClick={() => { if (!pending.current) onClose(); }}>{copy.cancel}</button>
      <button type="button" className="btn btn-primary" disabled={busy} onClick={() => void submit()}>{copy.save}</button></>}>
    <div className="assistant-draft-action-review" aria-busy={busy}>
      {error ? <p role="alert">{error}</p> : null}
      <p>{copy.review}</p><strong>{action.title}</strong>
      <dl>{assistantDraftReviewFields(action, language).map(field => <div key={field.label}>
        <dt>{field.label}</dt><dd>{field.value}</dd>
      </div>)}</dl>
    </div>
  </FormModal>;
}
